import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import FastViewService from "~/components/popups/fastViewService";
import OrderInstall from "~/components/popups/forms/orderInstall";
import Scheme from "~/components/popups/scheme";
import Vacancy from "~/components/popups/forms/vacancy";
import FeedBack from "~/components/popups/forms/feedBack";
import Message from "~/components/popups/forms/message";
import clsx from "clsx";
import styles from "./index.module.scss";
import { popupTypes } from "../../redux/reducers/popupReducer";
import Auth from "./auth";
import BackCall from "./forms/backCall";
import Cart from "./cart";
import FindLowPrice from "./forms/findLowPrice";
import LocationNew from "./locationNew";
import BuyOneClick from "./forms/buyOneClick";
import { showPopup } from "../../redux/action-creaters/popup";
import AddQuestion from "./forms/addQuestion";
import AddReview from "./forms/addReview";
import ServiceOrder from "./forms/serviceOrder";
import ServiceQuestion from "./forms/serviceQuestion";
import Video from "./video";
import SubscribeProduct from "./forms/subscribeProduct";
import ProductVideo from "./productVideo";
import ProductReviews from "./productReviews";
import ProductQuestions from "./productQuestions";
import Slider from "./slider";
import VideoFull from "./VideoFull";
import SimilarProduct from "./forms/similarProduct";
import AdminFeedback from "./adminFeedback";
import SelectElectrics from "./selectElectrics";
import CartEmpty from "./cartEmpty";
import OrderWithInstall from "./forms/orderWithInstall";
import InterceptorPageDepth4 from "./forms/interceptorPageDepth4";
import InterceptorExitModelCatalog from "./forms/interceptorExitModelCatalog";
import InterceptorTimeOnSite3min from "./forms/interceptorTimeOnSite3min";
import InstallCalculatorPopup from "./installCalculator";
import InstallWarning from "./installWarning";

export default function Popups() {
  const { visibleType } = useSelector((state) => state.popup);
  const dispatch = useDispatch();

  const isFormPopup =
    visibleType === popupTypes.backCall ||
    visibleType === popupTypes.findLowPrice ||
    visibleType === popupTypes.feedBack ||
    visibleType === popupTypes.message ||
    visibleType === popupTypes.serviceOrder ||
    visibleType === popupTypes.serviceQuestion ||
    visibleType === popupTypes.orderInstall ||
    visibleType === popupTypes.orderWithInstall ||
    visibleType === popupTypes.vacancy ||
    visibleType === popupTypes.subscribeProduct ||
    visibleType === popupTypes.similarProduct ||
    visibleType === popupTypes.addQuestion ||
    visibleType === popupTypes.addReview ||
    visibleType === popupTypes.buyOneClick ||
    visibleType === popupTypes.interceptorPageDepth4 ||
    visibleType === popupTypes.interceptorExitModelCatalog ||
    visibleType === popupTypes.interceptorTimeOnSite3min;

  const onHide = () => {
    dispatch(showPopup(popupTypes.none));
  };

  const handleKeyDown = (event) => {
    if (event.key === "Escape" && visibleType !== popupTypes.none) {
      onHide();
    }
  };

  useEffect(() => {
    // @ts-ignore
    if (typeof ym !== "undefined") {
      // eslint-disable-next-line no-undef
      ym(20518312, "reachGoal", "openWebForm");
    }
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [visibleType]);

  return (
    visibleType !== popupTypes.none && (
      <noindex>
        <span dangerouslySetInnerHTML={{ __html: "<!--googleoff: all-->" }} />
        <div
          className={styles.Wrapper}
          onClick={onHide}
          aria-label="Закрыть окно"
        >
          <div
            className={clsx(
              styles.Popup,
              isFormPopup && styles.PopupForm,
              "popup",
            )}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className={styles.Close}
              onClick={onHide}
              aria-label="Закрыть окно"
            >
              <svg
                width="54"
                height="54"
                viewBox="0 0 54 54"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 0H46C50.4183 0 54 3.58172 54 8V54H30C13.4315 54 0 40.5685 0 24V0Z"
                  fill="#FFEFEE"
                />
                <path
                  d="M20 20L34 34"
                  stroke="#D92D20"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <path
                  d="M34 20L20 34"
                  stroke="#D92D20"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </button>
            <div className={styles.Content} data-test={`${visibleType}Form`}>
              {visibleType === popupTypes.auth && <Auth onHide={onHide} />}
              {visibleType === popupTypes.backCall && (
                <BackCall onHide={onHide} />
              )}
              {visibleType === popupTypes.cart && <Cart onHide={onHide} />}
              {visibleType === popupTypes.findLowPrice && (
                <FindLowPrice onHide={onHide} />
              )}
              {visibleType === popupTypes.locationNew && (
                <LocationNew onHide={onHide} />
              )}
              {visibleType === popupTypes.buyOneClick && (
                <BuyOneClick onHide={onHide} />
              )}
              {visibleType === popupTypes.addQuestion && (
                <AddQuestion onHide={onHide} />
              )}
              {visibleType === popupTypes.addReview && (
                <AddReview onHide={onHide} />
              )}
              {visibleType === popupTypes.serviceOrder && (
                <ServiceOrder onHide={onHide} />
              )}
              {visibleType === popupTypes.orderInstall && (
                <OrderInstall onHide={onHide} />
              )}
              {visibleType === popupTypes.serviceQuestion && (
                <ServiceQuestion onHide={onHide} />
              )}
              {visibleType === popupTypes.video && <Video />}
              {visibleType === popupTypes.videoFull && <VideoFull />}
              {visibleType === popupTypes.subscribeProduct && (
                <SubscribeProduct />
              )}
              {visibleType === popupTypes.similarProduct && <SimilarProduct />}
              {visibleType === popupTypes.slider && <Slider />}
              {visibleType === popupTypes.productVideo && <ProductVideo />}
              {visibleType === popupTypes.productReviews && <ProductReviews />}
              {visibleType === popupTypes.productQuestions && (
                <ProductQuestions />
              )}
              {visibleType === popupTypes.fastViewService && (
                <FastViewService />
              )}
              {visibleType === popupTypes.scheme && <Scheme />}
              {visibleType === popupTypes.vacancy && <Vacancy />}
              {visibleType === popupTypes.feedBack && <FeedBack />}
              {/* visibleType === popupTypes.assortment && (
                        <Assortment/>
                    ) */}
              {visibleType === popupTypes.message && <Message />}
              {visibleType === popupTypes.cartEmpty && <CartEmpty />}

              {visibleType === popupTypes.adminFeedback && <AdminFeedback />}
              {visibleType === popupTypes.selectElectrics && (
                <SelectElectrics />
              )}
              {visibleType === popupTypes.orderWithInstall && (
                <OrderWithInstall />
              )}
              {visibleType === popupTypes.interceptorPageDepth4 && (
                <InterceptorPageDepth4 />
              )}
              {visibleType === popupTypes.interceptorExitModelCatalog && (
                <InterceptorExitModelCatalog />
              )}
              {visibleType === popupTypes.interceptorTimeOnSite3min && (
                <InterceptorTimeOnSite3min />
              )}
              {visibleType === popupTypes.installCalculator && (
                <InstallCalculatorPopup />
              )}
              {visibleType === popupTypes.installWarning && <InstallWarning />}
            </div>
          </div>
        </div>
        <span dangerouslySetInnerHTML={{ __html: "<!--/googleoff: all-->" }} />
      </noindex>
    )
  );
}
